export const PERFORMANCE_RECOMMENDATIONS_ACTION_TYPES = {
    TARGET_CPA: 'APPLY_TARGET_CPA',
    UNREALISTIC_TCPA: 'APPLY_TARGET_CPA',
    AUDIENCE_IC: 'APPLY_AUDIENCE_TARGETING',
    AUDIENCE_RETARGETING_IC: 'APPLY_AUDIENCE_TARGETING',
};
